import { useState } from 'react';
import { message } from 'antd'
import { admissionService } from "../../../services/admission";

const useUpdatePaymentMethod = () => {
  const [isLoading, setIsLoading] = useState(false);

  const submit = async (params) => {
    try {
      setIsLoading(true);
      const response = await admissionService.updatePaymentMethods(params);
      message.success({
        content: "Métodos de pago actualizados exitosamente",
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setIsLoading(false)
    }
  }

  return { submit, isLoading };
}

export default useUpdatePaymentMethod;